import { accountTitleSX, panelMobileSX } from '@/components/content/Header/styles/account/panel';
import { useLocalization } from '@/data/Localization';
import { useUser } from '@/data/User';
import { Box, Divider, Paper, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';

import { ExtraLinksSection } from '@/components/content/Header/parts/HDMAccountPanel/ExtraLinksSection';
import { LoginRequestSection } from '@/components/content/Header/parts/HDMAccountPanel/LoginRequestSection';
import { ProBoostSection } from '@/components/content/Header/parts/HDMAccountPanel/ProBoostSection';
import { QuickLinksSection } from '@/components/content/Header/parts/HDMAccountPanel/QuickLinksSection';
import { accountSX } from '@/components/content/Header/styles/account/account';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import { OPEN_CLOSE_STATES, OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

type Props = {
	onClose: (event: React.MouseEvent<HTMLElement> | null, action?: OPEN_CLOSE_STATES) => void;
};
export const AccountDropMenuPanel: FC<Props> = ({ onClose }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
	const HeaderAccountPanelLabels = useLocalization('HeaderAccountPanel');
	const { user } = useUser();
	const isLoggedIn = !!user?.isLoggedIn;

	return (
		<Paper elevation={isMobile ? 4 : 6} sx={panelMobileSX.container(theme)} id="accountPanel">
			<Stack sx={accountTitleSX.container}>
				<Box sx={accountTitleSX.containerTitle}>
					{isMobile ? <PersonIcon sx={accountSX.icon(theme)} /> : null}
					<Typography
						variant='headingSegment'
						fontWeight={OpenSansFontWeights.light}
						sx={accountTitleSX.title}
					>
						{HeaderAccountPanelLabels.Title.t()}
					</Typography>
				</Box>
				{isMobile ? (
					<CloseIcon
						onClick={() => onClose(null, OPEN_CLOSE_STATES.CLOSE)}
						sx={panelMobileSX.closeIcon(theme)}
					/>
				) : null}
			</Stack>
			<Divider sx={panelMobileSX.divider(theme)} />

			{!isLoggedIn ? (
				<LoginRequestSection theme={theme} onClose={() => onClose(null, OPEN_CLOSE_STATES.CLOSE)} />
			) : null}

			{!isLoggedIn ? <ProBoostSection /> : null}

			<QuickLinksSection
				theme={theme}
				isLoggedIn={isLoggedIn}
				onClose={() => onClose(null, OPEN_CLOSE_STATES.CLOSE)}
			/>

			{isLoggedIn ? <ProBoostSection /> : null}

			<ExtraLinksSection
				isLoggedIn={isLoggedIn}
				closeModal={() => onClose(null, OPEN_CLOSE_STATES.CLOSE)}
			/>
		</Paper>
	);
};
